import React, { FC } from 'react'
import { Modal, Button, Form, Spinner } from 'react-bootstrap'

interface ModalAddSourcesProps {
    show: boolean
    onHide: () => void
    onSubmit: () => void
    alias: string
    link: string
    onAliasChange: (value: string) => void
    onLinkChange: (value: string) => void
    isLoading?: boolean
}

const ModalAddSources: FC<ModalAddSourcesProps> = ({
    show,
    onHide,
    onSubmit,
    alias,
    link,
    onAliasChange,
    onLinkChange,
    isLoading = false,
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Source</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Alias</Form.Label>
                    <Form.Control
                        value={alias}
                        placeholder="e.g. EN, WTO, WIPO"
                        onChange={(e) => onAliasChange(e.target.value)}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                        value={link}
                        placeholder="https://example.com/file.xml"
                        onChange={(e) => onLinkChange(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="default" onClick={onHide}>
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={onSubmit}
                    disabled={!alias.trim() || !link.trim() || isLoading}
                >
                    {isLoading ? (
                        <>
                            <Spinner animation='border' size='sm' className='me-2' />
                            Submitting...
                        </>
                    ) : (
                        'Submit'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalAddSources
